import { isRouteProducts, navigate } from '../../../helpers/history';
import { buildProductGridItemPath } from '../../../components/ProductItem/helpers/resolveProductGridItemNavigation';

export default function openDraftProductRecord({ productId, variantId } = {}) {
  if (!productId) return false;

  const path = buildProductGridItemPath({
    masterProductId: productId,
    ...(variantId ? { masterVariantId: variantId } : {}),
  });
  if (!path) return false;

  if (!isRouteProducts()) return true;

  navigate(path);
  return true;
}
